function ContactData() {
  var self = this

  this.init = function(success) {
    if (window.session.hasContactData()) {
      success()
    }
    else {
      showDialog(success)
    }
  }

  function showDialog(success) {
    var modal = $('#contactModal').modal('show')
    modal.find('form [name=phone]').val(session.user.phone)
    modal.find('form [name=email]').val(session.user.email)

    modal.find('form').off('submit').on('submit', function () {
      return self.submit(modal, success)
    })
  }

  this.submit = function (modal, success) {
    var form = modal.find('form')
    var phone = form.find('[name=phone]')
    var email = form.find('[name=email]')
    $.post('/user', {phone: phone.val(), email: email.val()})
      .done(function () {
        modal.on('hidden.bs.modal', success).modal('hide')
        window.session.user.phone = phone.val()
        window.session.user.email = email.val()
      })
      .fail(function (xhr) {
        phone.closest('div').toggleClass('has-danger', !!xhr.responseJSON.validationErrors.phone)
        email.closest('div').toggleClass('has-danger', !!xhr.responseJSON.validationErrors.email)
      })
    return false
  }
}